const LENDERS = [
  { name: "Commonwealth Bank", domain: "commbank.com.au" },
  { name: "Westpac", domain: "westpac.com.au" },
  { name: "NAB", domain: "nab.com.au" },
  { name: "ANZ", domain: "anz.com.au" },
  { name: "Macquarie", domain: "macquarie.com.au" },
  { name: "ING", domain: "ing.com.au" },
  { name: "Bankwest", domain: "bankwest.com.au" },
  { name: "St.George", domain: "stgeorge.com.au" },
  { name: "Suncorp", domain: "suncorp.com.au" },
  { name: "AMP", domain: "amp.com.au" },
  { name: "ME Bank", domain: "mebank.com.au" },
  { name: "HSBC", domain: "hsbc.com.au" },
];

const logoFor = (domain) =>
  `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;

export const LenderPartners = () => {
  return (
    <section
      data-testid="lender-partners"
      className="py-20 md:py-24 bg-brand-sand border-y border-border"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-12">
          <div className="label-eyebrow text-brand-terracotta/90">
            Trusted with 40+ Australian lenders
          </div>
          <h2 className="mt-3 font-display text-2xl sm:text-3xl tracking-tight text-brand-ink max-w-3xl">
            We work with the banks so you don&apos;t have to.
          </h2>
        </div>

        <div
          data-testid="lender-grid"
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4"
        >
          {LENDERS.map((l) => (
            <div
              key={l.domain}
              data-testid={`lender-${l.domain.split(".")[0]}`}
              title={l.name}
              className="group rounded-xl border border-border bg-brand-cream/70 backdrop-blur-sm px-4 py-5 flex items-center justify-center gap-3 transition-all duration-300 hover:bg-brand-cream hover:-translate-y-0.5 hover:shadow-sm"
            >
              <img
                src={logoFor(l.domain)}
                alt={`${l.name} logo`}
                loading="lazy"
                className="h-7 w-7 object-contain shrink-0"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
              <span className="font-display text-sm md:text-[15px] tracking-tight text-brand-ink/80 group-hover:text-brand-terracotta transition-colors truncate">
                {l.name}
              </span>
            </div>
          ))}
        </div>

        <p className="mt-8 text-xs text-brand-ink/50 max-w-3xl">
          A selection of the panel lenders we work with. Logos are the property
          of their respective owners and shown for identification only.
        </p>
      </div>
    </section>
  );
};
